import React from 'react'
import DashboardMenu from '../../Components/DashboardMenu'
import { PageWrapper } from '../../Styles/style'
import S1_Dashboard from './S1_DAshboard/Index'

const Dashboard = () => {
  return (
    <div>
        <PageWrapper>

        <DashboardMenu/>
        <S1_Dashboard/>
        </PageWrapper>
    </div>
  )
}

export default Dashboard